export default {
    data () {
        return {
            oauth: {
                loading: 0,
                uid: 0,
                status: 0,
                accessToken: '',
                status: 0
            }
        }
    },
    methods: {
        createToken(uid) {
            this.oauth.accessToken = false;
            this.$root.oauth.accessToken = false;

            if (!this.loading) {
                this.$http.get(api+'oauth/v2/create/token')

                    .then(response => {

                    this.$root.oauth.status = response.status;
                    this.oauth.accessToken = response.body.access_token;
                    this.authentication(uid)

            }, response => {

                    this.$root.oauth.status = response.status;

                });
            }
        },
        authentication(uid) {

            if (!this.loading) {
                this.$http.get(api+'api/oauth/v2/create/session', {params: {uid: uid, token: this.oauth.accessToken}})
                    .then(response => {

                this.oauth.accessToken = response.body.access_token;
                this.$root.oauth.accessToken = response.body.access_token;

                this.$bus.$emit('OAUTH_TOKEN', response.body.access_token)

                this.$root.oauth.status = 200;

                this.loading = false;
            }, response => {
                this.loading = false;
                    this.$root.oauth.status = response.status;

                });
            }

        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/oauth2.js